import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const { t } = useTranslation();

  const galleryImages = [
    {
      id: 1,
      url: 'https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
      title: t('gallery.items.whiteOak4.title'),
      description: t('gallery.items.whiteOak4.description')
    },
    {
      id: 2,
      url: 'https://images.unsplash.com/photo-1560185007-cde436f6a4d0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
      title: t('gallery.items.redOakClassic.title'),
      description: t('gallery.items.redOakClassic.description')
    },
    {
      id: 3,
      url: 'https://images.unsplash.com/photo-1556909114-44e3e70034e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
      title: t('gallery.items.widePlank.title'),
      description: t('gallery.items.widePlank.description')
    },
    {
      id: 4,
      url: 'https://images.unsplash.com/photo-1556909212-d5b604d0c90d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
      title: t('gallery.items.herringbone.title'),
      description: t('gallery.items.herringbone.description')
    },
    {
      id: 5,
      url: 'https://images.unsplash.com/photo-1615971677499-5467cbab01c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
      title: t('gallery.items.darkWalnut.title'),
      description: t('gallery.items.darkWalnut.description')
    },
    {
      id: 6,
      url: 'https://images.unsplash.com/photo-1416339698674-4f118dd3388b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
      title: t('gallery.items.grayWashed.title'),
      description: t('gallery.items.grayWashed.description')
    }
  ];

  return (
    <section id="gallery" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-wood-dark mb-4">
            {t('gallery.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('gallery.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer transform transition duration-300 hover:scale-105"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-white text-xl font-semibold mb-2">
                    {image.title}
                  </h3>
                  <p className="text-gray-200 text-sm">
                    {image.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal for enlarged image */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-4xl w-full">
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="w-full h-auto rounded-lg"
              />
              <div className="absolute top-4 right-4">
                <button
                  className="text-white text-4xl hover:text-gray-300 transition-colors"
                  onClick={() => setSelectedImage(null)}
                >
                  ×
                </button>
              </div>
              <div className="mt-4 text-center">
                <h3 className="text-white text-2xl font-semibold mb-2">
                  {selectedImage.title}
                </h3>
                <p className="text-gray-300">
                  {selectedImage.description}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery; 